import DashboardSharedTable from "./common/DashboardSharedTable";
import { formatUTCDateShort } from "@demandproai/shared";
import { useSuperDashboardContext } from "../superdashboard/context/SuperDashboardContext";
import { statCardClasses } from "../../../components/common/dashboardClasses";

const CompaniesTable = () => {
    const { companiesData, openModalByKey } = useSuperDashboardContext();

    return (
        <DashboardSharedTable
            title="Upcoming Contract Renewals"
            columns={[
                { header: "Company", dataKey: "companyName" },
                { header: "Tier", dataKey: "tier" },
                { header: "Renewal Date", dataKey: "renewalDate", render: (row) => formatUTCDateShort(row.renewalDate) },
                { header: "Days Left", dataKey: "remainingDays" }
            ]}
            data={companiesData}
            className={statCardClasses}
            openModal={openModalByKey}
            limit={4}
        />
    );
};

export default CompaniesTable;
